import { Component, OnInit } from '@angular/core';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faFacebook, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { AnalitycsService } from './services/analitycs.service';
import { CategoryService } from './services/category.service';
import { NewsService } from './services/news.service';
import { PublicityService } from './services/publicity.service';
import { RadioService } from './services/radio.service';
import { VideoService } from './services/video.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'RadioCenNuevo';
  faInstagram = faInstagram;
  faFacebook = faFacebook;
  faTwiter= faTwitter;
  faYoutube=faYoutube;
  faMapMarkerAlt=faMapMarkerAlt;
  btnchecked:any
  listado:any
  timeout:any;
  city:string;
  country:string;
  constructor(
    private category: CategoryService,
    private news: NewsService,
    private publicity: PublicityService,
    private radio: RadioService,
    private video: VideoService,
    private analytics: AnalitycsService
  ){

  }
  ngOnInit(){
    this.verifyCheckMenu(document);
  }

  public verifyCheckMenu(d:any){
    this.btnchecked = d.getElementsByName('btncheck')[0];
    this.listado = d.getElementsByClassName('weightnew');

    for (let index = 0; index < this.listado.length; index++) {
      const element = this.listado[index];
      element.addEventListener('click',(data)=>{
          d.getElementsByName('btncheck')[0].checked = false;
        })

    }

    this.btnchecked.addEventListener('change', function (data){
      if(data.srcElement.checked){
        this.timeout= setTimeout(()=>{
          data.srcElement.checked = false;
        },4000)
      }
      else{
        clearTimeout(this.timeout);
      }
    })
  }


}
